module.exports = __webpack_public_path__ + "static/media/paris_1701970945294_old.d11b7706.png";